module.exports = __webpack_public_path__ + "static/fraud-prevention-96aac1f95e53d6fc97bafd7f258ef093.jpg";